import {
  jb_service_navigation_css_default
} from "./chunk.UUG265KS.js";
import {
  Rt
} from "./chunk.DS2KVX5X.js";
import {
  reset_css_default
} from "./chunk.PBU2AIHD.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  ke,
  r
} from "./chunk.NBIYIO67.js";
import {
  n
} from "./chunk.QXWAL3TN.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-service-navigation/jb-service-navigation.ts
var JbServiceNavigation = class extends r {
  _activateVisibleItems() {
    this._getVisibleItems().forEach((item) => {
      item.shadowRoot.querySelector("span")?.setAttribute("tabindex", "0");
    });
  }
  _focusNextItem(currentItem) {
    const visibleItems = this._getVisibleItems();
    const currentItemIndex = this._getCurrentItemIndex(currentItem);
    const nextItem = visibleItems[currentItemIndex + 1];
    if (nextItem) {
      nextItem.shadowRoot.querySelector("span")?.focus();
    }
  }
  _focusPreviousItem(currentItem) {
    const visibleItems = this._getVisibleItems();
    const currentItemIndex = this._getCurrentItemIndex(currentItem);
    const previousItem = visibleItems[currentItemIndex - 1];
    if (previousItem) {
      previousItem.shadowRoot.querySelector("span")?.focus();
    }
  }
  _getCurrentItemIndex(item) {
    let index = 0;
    this._getVisibleItems().forEach((visibleItem, i) => {
      if (visibleItem === item) {
        index = i;
      }
    });
    return index;
  }
  _getVisibleItems() {
    return Array.from(this.children).filter((item) => {
      const listElement = item.shadowRoot.querySelector("span");
      return listElement.clientHeight !== 0;
    });
  }
  _handleFocus() {
    this._activateVisibleItems();
  }
  _handleKeyboardEvent(evt) {
    const firstVisibleItem = this._getVisibleItems()[0];
    const jbMenu = document.querySelector("jb-menu");
    let keyCode = evt.code;
    if (evt.key === "Tab" && evt.shiftKey) {
      keyCode = "Shift+Tab";
    }
    switch (keyCode) {
      case "ArrowLeft":
        this._focusPreviousItem(evt.target);
        break;
      case "Tab":
      case "ArrowRight":
        this._focusNextItem(evt.target);
        break;
      case "Enter":
      case "Space":
        evt.preventDefault();
        evt.target.shadowRoot.querySelector("a")?.click();
        break;
      case "Shift+Tab":
        if (firstVisibleItem === evt.target && document.querySelector("jb-overlay")) {
          evt.preventDefault();
          if (jbMenu.shadowRoot.querySelector("nav.mobile-menu")) {
            jbMenu.shadowRoot.querySelector("jb-menu-item")?.focus();
          } else {
            jbMenu?.focus();
          }
          this.dispatchEvent(new CustomEvent("jb-focus-fly:reset", { bubbles: true, composed: true }));
        }
        break;
      default:
        break;
    }
  }
  render() {
    return ke`
      <div
        class=${Rt({
      "service-navigation": true,
      "service-navigation--hide-first": this.hideItems === "first",
      "service-navigation--hide-all-except-first": this.hideItems === "all-except-first",
      "service-navigation--hide-all": this.hideItems === "all"
    })}
        role="list"
        @keydown=${this._handleKeyboardEvent}
        @focus=${this._handleFocus}
      >
        <slot></slot>
      </div>
    `;
  }
};
JbServiceNavigation.styles = [reset_css_default, jb_service_navigation_css_default];
JbServiceNavigation.shadowRootOptions = { ...r.shadowRootOptions, delegatesFocus: true };
__decorateClass([
  n()
], JbServiceNavigation.prototype, "hideItems", 2);
JbServiceNavigation = __decorateClass([
  customElement("jb-service-navigation")
], JbServiceNavigation);

export {
  JbServiceNavigation
};
